import { render, staticRenderFns } from "./PaymentMethodSelectorCheckout.vue?vue&type=template&id=31de3992&scoped=true&"
import script from "./PaymentMethodSelectorCheckout.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodSelectorCheckout.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodSelectorCheckout.vue?vue&type=style&index=0&id=31de3992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de3992",
  null
  
)

export default component.exports